// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"W","content":"X","header":"Y","message":"Z","iframeWrapper":"aa"};